import {
  TCountryDomainCode,
  TLangCodePrefix,
  countryDomainCode,
  langCodePrefix,
} from '../../../../constants/staticPageConstants';
import { TDropdownList } from '../../../Header/DynamicHeader/Dropdown/DropdownComponent';

export const HeaderFrLanguageDropDown = (
  isMultiLang: boolean,
  permalink: string,
  domainval: number
): TDropdownList | undefined => {
  const slug = linkGeneration(domainval);

  const DROPDOWN_DATA = [
    {
      name: 'English',
      link: `https://www.cleartax.com/${slug}/en/${permalink}`,
    },
    {
      name: langCodePrefix[
        countryDomainCode[domainval as TCountryDomainCode] as TLangCodePrefix
      ],
      link: `https://www.cleartax.com/${slug}/${permalink}`,
    },
  ];
  if (isMultiLang) {
    return DROPDOWN_DATA;
  }

  function linkGeneration(domainVal: number) {
    return countryDomainCode[domainVal as TCountryDomainCode];
  }
  return;
};
